export enum EFilters {
	ACTION_DATE_FROM = 'createdAtAfter',
	ACTION_DATE_TO = 'createdAtBefore',
	CAP = 'capIsReached',
	CAP_AMOUNT_FROM = 'capGte',
	CAP_AMOUNT_TO = 'capLte',
	CATEGORY = 'category',
	SOCIAL_MEDIA = 'social_media',
	DATE_FROM = 'createdAfter',
	DATE_TO = 'createdBefore',
	GEO = 'country',
	MMP_LINK = 'mmpLink',
	OFFER = 'uuid',
	OFFER_ID = 'offerId',
	READ = 'read',
	SEARCH = 'search',
	SOURCE = 'sourceId',
	STATUS = 'status',
	TYPE = 'type',
	PRICE_FROM = 'priceFrom',
	PRICE_UNTIL = 'priceUntil',
	TRAFFIC = 'trafficType',
}

export enum EFilterOptions {
	ALL = 'all',
}
